import React from 'react';
import './ClearButton.css';
import DeleteIcon from '@mui/icons-material/Delete';

const ClearButton = ({ onClear, controlsRowFlipped }) => {
  return (
    <button
      className="clear-button"
      onClick={onClear}
      aria-label="Clear puzzle"
    >
      <DeleteIcon sx={{ fontSize: 20 }} />
    </button>
  );
};

export default ClearButton; 